export default __webpack_public_path__ + "static/media/aston-about-image.bb83cb30.png";